import { render, staticRenderFns } from "./ConfigManutencao.vue?vue&type=template&id=6691ca85&"
import script from "./ConfigManutencao.vue?vue&type=script&lang=js&"
export * from "./ConfigManutencao.vue?vue&type=script&lang=js&"
import style0 from "./ConfigManutencao.vue?vue&type=style&index=0&id=6691ca85&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports